import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() sidenav: MatSidenav;
  loggedInObj: any;
  constructor(private readonly storage: LocalStorageService, private readonly router: Router, private readonly http: HttpClient) {

  }
  ngOnInit() {
    this.loggedInObj = this.storage.retrieve('loginobj');
  }

  logOut(): void {
    this.storage.store('isLoggedin', false);
    this.sidenav.close();
    this.storage.clear();
    this.router.navigate(['/login']);
  }
}
